<template>
    <v-card>
        <v-card-title>
            <v-spacer></v-spacer>
            <v-btn icon @click="confirm()"><v-icon>mdi-close</v-icon></v-btn>
        </v-card-title>
        <v-container class="p-4 text-center">
            <h1 class="m-3 mb-5">Seasonal Reservation Alert!</h1>
            <template>
                <h5 class="mb-5 mt-5">📢 Our ski rental season begins on {{season_start_date}} – bookings will be available from that day.</h5>
                <h5 class="mb-5 mt-5">Thank you for your patience – we look forward to welcoming you soon!</h5>
            </template>
            <div class="cmt-30 mb-5">
                <v-btn color="primary" @click="confirm()">Close</v-btn>
            </div>

        </v-container>
    </v-card>
</template>

<script>

import moment from "moment";
export default {
    name: "DialogSeasonalReservation",
    computed: {
        site_name() {
            return this.$store.state.resources.config.site_name;
        },
        season_start_date() {
            return moment(new Date(this.$store.state.resources.config.season_start)).format("MM/DD/YYYY");
        },
    },
    methods:{
        confirm(){
            this.$store.dispatch('focusInput', 'secondModalInput');
            this.$emit('modal-close')
        }
    },
}
</script>

<style scoped>
    .min-height-200{
        min-height: 200px;
    }
    .cmt-30{
        margin-top: 70px;
    }
</style>
